import { Button, Stack } from '@mantine/core';
import { Link } from 'react-router-dom';

import { PageTitle } from '../components/PageTitle';
import { ru } from '../i18n/ru';

export function NotFoundPage() {
  return (
    <Stack gap="xl" align="flex-start">
      <PageTitle title={ru.common.notFound} />
      <Button component={Link} to="/" variant="default">
        {ru.common.backHome}
      </Button>
    </Stack>
  );
}
